import React, { useContext } from "react";
import "./Intro.css";
import Vector1 from "../../img/Vector1.png";
import Vector2 from "../../img/Vector2.png";
import boy from "../../img/edd.png";
import glassesimoji from "../../img/glassesimoji.png";
import thumbup from "../../img/thumbup.png";
import crown from "../../img/crown.png";
import FloatinDiv from "../FloatingDiv/FloatingDiv";
import Github from "../../img/github.png";
import LinkedIn from "../../img/linkedin.png";
import Instagram from "../../img/instagram.png";
import twitter from "../../img/twitter.png";

import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import { Link } from "react-scroll";
const Intro = () => {
  // Transition
  const transition = { duration: 2, type: "spring" };

  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="Intro" id="Intro">
      {/* left name side */}
      <div className="i-left">
        <div className="i-name">
          <span className="intro_name" style={{ color: darkMode ? "white" : "" }}>Hello! I Am</span>
          <span className="name">Edward Michira,</span>
          <span>
          A highly experienced and results-driven Full Stack Web Developer with over 6 years of experience in designing, developing,
          and deploying scalable and user-centric web applications. Proven ability to leverage a wide range of modern technologies, including HTML, CSS, JavaScript, React.js, Node.js, Express.js, and MongoDB, to create robust and efficient solutions. Expertise in both front-end and back-end development, with a strong focus on optimizing application performance, implementing secure authentication and authorization, and integrating various APIs and services. A collaborative team player with excellent communication and problem-solving skills, committed to continuous learning and staying at the forefront of emerging technologies.
          Passionate about building innovative digital solutions that drive business value.
          </span>
        </div>
        <Link to="contact" smooth={true} spy={true}>
          <button className="button i-button">Let's talk</button>
        </Link>
        {/* social icons */}
        <div className="i-icons">
          <a href="https://github.com/zixx-bit" target="_blank" rel="noopener noreferrer">
            <img src={Github} alt="GitHub" />
          </a>
          <a href="https://www.linkedin.com/in/eddmichira/" target="_blank" rel="noopener noreferrer">
            <img src={LinkedIn} alt="LinkedIn" />
          </a>
          <a href="https://x.com/EddMichira" target="_blank" rel="noopener noreferrer">
            <img src={twitter} alt="twitter" height={120} width={120}/>
          </a>
        </div>
      </div>
      {/* right image side */}
      <div className="i-right">
        <img src={Vector1} alt="" />
        <img src={Vector2} alt="" />
        {/* <img src={boy} alt="" /> */}
        <img src={boy} alt="" width={350} height={400} style={{borderRadius: "50%", marginLeft: "-50px", marginTop: "-100px"}} />

        {/* animation */}
        <motion.img
          initial={{ left: "-36%" }}
          whileInView={{ left: "-24%" }}
          transition={transition}
          src={glassesimoji}
          alt=""
        />

        <motion.div
          initial={{ top: "-4%", left: "74%" }}
          whileInView={{ left: "68%" }}
          transition={transition}
          className="floating-div"
        >
          <FloatinDiv img={crown} text1="Web" text2="Developer" />
        </motion.div>

        {/* animation */}
        <motion.div
          initial={{ left: "9rem", top: "18rem" }}
          whileInView={{ left: "0rem" }}
          transition={transition}
          className="floating-div"
        >
          {/* floatinDiv mein change hy dark mode ka */}
          <FloatinDiv img={thumbup} text1="Developer" text2="Award" />
        </motion.div>

        <div className="blur" style={{ background: "rgb(238 210 255)" }}></div>
        <div
          className="blur"
          style={{
            background: "#C1F5FF",
            top: "17rem",
            width: "21rem",
            height: "11rem",
            left: "-9rem",
          }}
        ></div>
      </div>
    </div>
  );
};

export default Intro;
